<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>

<main>
    <app-bukku-banner></app-bukku-banner>
    <div class="tw-py-[50px] lg:tw-py-[100px]">
        <div
            class="tw-max-w-[1280px] tw-px-[25px] md:tw-px-[30px] xl:tw-px-0 tw-mx-auto"
        >
            <h3
                class="!tw-text-[#0F3172] !tw-text-[22px] md:!tw-text-[28px] !tw-font-bold !tw-text-center md:!tw-text-left"
            >
                {{ "DIGITAL_SERVICES.BUKKU.ABOUT_TITLE" | translate }}
            </h3>
            <p
                class="!tw-text-[#1A202C] !tw-text-[14px] !tw-text-center md:!tw-text-left"
            >
                {{ "DIGITAL_SERVICES.BUKKU.ABOUT_DESC" | translate }}
            </p>
            <!-- <p class="!tw-text-[#1A202C] !tw-text-[14px]">
                {{ "DIGITAL_SERVICES.SUB_DESC_2" | translate }}
            </p> -->
        </div>
    </div>
    <app-bukku-services></app-bukku-services>
    <app-bukku-pricing-plan></app-bukku-pricing-plan>
    <app-bukku-form
        [data]="data"
        [selectedLanguage]="selectedLanguage"
    ></app-bukku-form>
</main>

<app-footer [selectedLanguage]="selectedLanguage" />
